@if (copy) {
  <div class="b-radius-max"
    [ngClass]="[bgColor || 'bg-col-2', textColor || 'col-w', small ? 'p-t-1-s p-b-1-s p-l-2-s p-r-2-s s3' : 'p-t-2 p-b-2 p-l-5 p-r-5 s2']"
  >{{ copy | uppercase }}</div>
}
